/**
 * Created by pandemio on 4/12/19.
 */
import React from 'react';
import {Card, Col, Container, Row, Table, Button} from 'reactstrap';

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../../translations/global.json"
/** End of Multiple Language imports **/
import LanguageManager from '../../custom-classes/language-manager';
import NavbarDesktop from './navbar-employee/navbar-desktop';
import NavbarMobile from './navbar-employee/navbar-mobile';
import Footer from '../footer/footer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faIdBadge} from '@fortawesome/free-solid-svg-icons';
import ApiCalls from '../../custom-classes/api-calls';
import ChartBar from '../charts/chart-bar';
import PlanDataTable from '../datatables/plan-data-table';
import DatePicker from '../date-picker/date-picker-recent'

/**
 * Report page to see the subscriptions
 */
class ReportSubscriptions extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        let languages = [
            {name: "English", code: "en"},
            {name: "Español", code: "es"}
        ];

        // To support language library add the following lines
        this.props.initialize({
            languages,
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage()}
        });

        this.state = {
            languages: languages,
            planName: '',
            fromDate: null,
            toDate: null,
            planId: null
        };
        this.props.addTranslation(global);

        this.handlePlanSelected = this.handlePlanSelected.bind(this);
        this.handleSelectedFromDate = this.handleSelectedFromDate.bind(this);
        this.handleSelectedToDate = this.handleSelectedToDate.bind(this);
        this.showPlanBox = this.showPlanBox.bind(this);
    }

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.getLineChartData();

    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    handlePlanSelected(e){
        this.setState({
            planName: e.Name,
            planId: e.Id
        },()=>{
            this.getLineChartData()
        });
    }

    handleSelectedFromDate(e){
        this.setState({
            fromDate: e.date
        },()=>{
            this.getLineChartData()
        });
    }

    handleSelectedToDate(e){
        this.setState({
            toDate: e.date
        },()=>{
            this.getLineChartData()
        });
    }

    createTableData(data){

        let rows = [];
        for(let i=0; i < data.length;i++)
        {
            // If active, add the button;
            let row = <tr key={data[i].PlanId}>
                <td>{data[i].PlanId}</td>
                <td>{data[i].PlanName}</td>
                <td>{data[i].Active}</td>
                <td>{data[i].Canceled}</td>
                <td>{data[i].Trialing}</td>
            </tr>;
            rows.push(row);
        }
        this.setState({rows:rows});
    }

    showPlanBox(){
        this.setState({
            planId: null
        },()=>{
            this.getLineChartData()
        });
    }

    /**
     * Returns the main chart data
     */
    getLineChartData(){

        let apiCall =
            ApiCalls.getReportSubscription(this.state.planId,
                this.state.fromDate, this.state.toDate);
        apiCall.then((data)=> {

            this.createTableData(data.ReportSubscriptionResult);
            let cancelations = LanguageManager.getTranslation("dashboard-employee.subscriptions-cancelled", this.state.languages);// LanguageManager.getTranslation("dashboard-employee.subscriptions-cancelled", this.state.languages);
            let actives = LanguageManager.getTranslation("dashboard-employee.subscriptions-active", this.state.languages); //"Active"; //LanguageManager.getTranslation("dashboard-employee.subscriptions-active", this.state.languages);
            let trialing = LanguageManager.getTranslation("dashboard-employee.subscriptions-trialing", this.state.languages);

            // Do the API call
            var chartLineData = {
                labels: [LanguageManager.getTranslation("dashboard-employee.subscriptions", this.state.languages)],
                datasets: [
                    {
                        label: actives,
                        fillColor: 'rgba(51,255,153,1)',
                        strokeColor: 'rgba(51,255,153,1)',
                        pointColor: 'rgba(51,255,153,1)',
                        pointStrokeColor: '#fff',
                        pointHighlightFill: '#fff',
                        pointHighlightStroke: 'rgba(51,255,153,1)',
                        data: [data.TotalActive],
                    },
                    {
                        label: trialing,
                        fillColor: 'rgba(255,255,51,1)',
                        strokeColor: 'rgba(255,255,51,1)',
                        pointColor: 'rgba(255,255,51,1)',
                        pointStrokeColor: '#fff',
                        pointHighlightFill: '#fff',
                        pointHighlightStroke: 'rgba(255,255,51,1)',
                        data: [data.TotalTrialing],
                    },
                    {
                        label: cancelations,
                        fillColor: 'rgba(255,102,102,1)',
                        strokeColor: 'rgba(255,102,102,1)',
                        pointColor: 'rgba(255,102,102,1)',
                        pointStrokeColor: '#fff',
                        pointHighlightFill: '#fff',
                        pointHighlightStroke: 'rgba(255,102,102,1)',
                        data: data.TotalCanceled,
                    }
                ]
            };
            this.setState({
                triesChartData: chartLineData
            });
        });
    }

    /**
     * Renders the main dashboard
     * @returns {XML}
     */
    render() {
        return (
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}
                <div className="container-padding">
                    <Container className={this.state.navbarMobile ? "margin-top-mandatory-60" : null}>
                        <h2 className="font-now-bold white-text">
                            <FontAwesomeIcon icon={faIdBadge}/>{' '}
                            <Translate id="reports.subscriptions" options={{renderInnerHtml: true}}/>
                        </h2>
                        <small className="white-text">
                            <Translate id="reports.subscriptions-instructions" options={{renderInnerHtml: true}}/>
                        </small>
                        <hr/>
                        <Row>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <Card body className="card-blue-transparency">
                                    <Row>
                                        <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                            <h5><Translate id="reports.filter" options={{renderInnerHtml: false}}/></h5>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {
                                            this.state.planId === null || this.state.planId === '' ?
                                                <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                                    <PlanDataTable updateParent={this.handlePlanSelected}/>
                                                </Col> : null
                                        }
                                    </Row>
                                    <Row>
                                        {
                                            this.state.planId !== null && this.state.planId !== '' ?
                                                <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                                    <Translate id="reports.selected-plan"
                                                               options={{renderInnerHtml: false}}/>
                                                    : <span className="yellow-text"><b> {this.state.planName} </b></span> {' '}

                                                    <Button color="warning" onClick={this.showPlanBox}>
                                                        <Translate id="reports.select-a-plan"
                                                                   options={{renderInnerHtml: false}}/>
                                                    </Button>
                                                </Col> : null
                                        }
                                    </Row>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <Card body className="card-blue-transparency">
                                    <Row>
                                        <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                            <Translate id="reports.select-dates" options={{renderInnerHtml: false}}/>
                                        </Col>
                                        <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 12}}>
                                            <Translate id="reports.date-from" options={{renderInnerHtml: false}}/>
                                            <DatePicker updateParent={this.handleSelectedFromDate} />
                                        </Col>
                                        <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 12}}>
                                            <Translate id="reports.date-to" options={{renderInnerHtml: false}}/>
                                            <DatePicker updateParent={this.handleSelectedToDate} />
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <Card body className="text-center card-blue-transparency">
                                    {
                                        typeof this.state.triesChartData !== 'undefined' && this.state.triesChartData !== null ?
                                            <ChartBar data={this.state} /> : null
                                    }
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={{size:12}} md={{size:12}} sm={{size: 12}} xs={{size:12}}>
                                <Table className="card-darker-transparency" responsive>
                                    <thead>
                                    <tr>
                                        <th><Translate id="reports.plan-id" options={{renderInnerHtml: false}}/></th>
                                        <th><Translate id="reports.plan-name" options={{renderInnerHtml: false}}/></th>
                                        <th><Translate id="reports.active" options={{renderInnerHtml: false}}/></th>
                                        <th><Translate id="reports.cancelled" options={{renderInnerHtml: false}}/></th>
                                        <th><Translate id="reports.trialing" options={{renderInnerHtml: false}}/></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    { this.state.rows !== "0" ? this.state.rows : null }
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer/>
            </div>

        )
    };
}

export default withLocalize(ReportSubscriptions);